/**
 * CampCreateRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CampCreateRes
 */
export interface CampCreateRes {
  /** 营地ID */
  id?: string
}

/**
 * CampCreateRes Schema
 */
export const CampCreateResSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '营地ID',
      format: 'string',
      type: 'string',
      label: '营地ID',
    },
  },
  type: 'object',
}
